export const usePhoneMask = () => (input: string): string => {
  if (input === undefined || input === null) {
    return '';
  }
  const inputString = input?.toString();
  const inputValueToDigits = (input: string) => {
    return input?.replace(/\D/g, '');
  };
  const inputNumbers = inputValueToDigits(inputString);

  let formattedInput = '';

  if (inputNumbers.length > 0) {
    formattedInput += `(${inputNumbers.substring(0, 3)}`;
  }
  if (inputNumbers.length >= 4) {
    formattedInput += `) ${inputNumbers.substring(3, 6)}`;
  }
  if (inputNumbers.length >= 7) {
    formattedInput += `-${inputNumbers.substring(6, 8)}`;
  }
  if (inputNumbers.length >= 9) {
    formattedInput += `-${inputNumbers.substring(8, 10)}`;
  }

  return formattedInput;
};
